if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.quickViewDrawer = this.closest("quick-view-drawer");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading") || submitButton.dataset.state === "adding") {
          return;
        }

        this.handleErrorMessage();

        /* -- Save original button state -- */
        const buttonTextEl = submitButton.querySelector("span");
        const originalText = buttonTextEl ? buttonTextEl.textContent : submitButton.textContent;
        const originalBg = submitButton.style.backgroundColor;

        /* -- ADDING... state (red) -- */
        submitButton.setAttribute("aria-disabled", true);
        submitButton.style.pointerEvents = "none";
        if (buttonTextEl) {
          buttonTextEl.textContent = "ADDING...";
        }
        submitButton.style.backgroundColor = "#FF2D9B";
        submitButton.style.color = "#ffffff";
        submitButton.dataset.state = "adding";

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.minicart.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        let addedSuccessfully = false;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.minicart.updateSectionContents();
              return;
            }

            addedSuccessfully = true;

            this.minicart.renderContents(response);

            if (window.themeSettings.redirectToCart) {
              location.href = window.routes.cart_url;
            } else {
              if (this.quickViewDrawer) {
                this.quickViewDrawer.close();
              }
            }

            const event = new CustomEvent("cart:item-add", {
              detail: {
                items: [response],
                context: this.eventContext,
              },
            });
            document.dispatchEvent(event);

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: this.eventContext,
              items: [response],
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.removeAttribute("aria-disabled");
            submitButton.style.pointerEvents = "";

            if (addedSuccessfully) {
              /* -- ADDED! state (stay red) -- */
              if (buttonTextEl) {
                buttonTextEl.textContent = "ADDED!";
              }
              submitButton.style.backgroundColor = "#FF2D9B";
              submitButton.style.color = "#ffffff";
              submitButton.dataset.state = "added";

              /* -- Restore original after 1.5s -- */
              setTimeout(() => {
                if (buttonTextEl) {
                  buttonTextEl.textContent = originalText;
                }
                submitButton.style.backgroundColor = originalBg;
                submitButton.style.color = "";
                delete submitButton.dataset.state;
              }, 1500);
            } else {
              /* Error or no change -- restore immediately */
              if (buttonTextEl) {
                buttonTextEl.textContent = originalText;
              }
              submitButton.style.backgroundColor = originalBg;
              submitButton.style.color = "";
              delete submitButton.dataset.state;
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
